import layoutStyles from "../../pages/Layout.module.scss";
import styles from "./VersionInformationBanner.module.scss";
import { Link } from "react-router-dom";
import React, {useState} from "react";
import { useTranslation} from "react-i18next";
import Icon from "../Icon";

const VersionInformationBanner = () => {
    const { t } = useTranslation();
    const [isVersionBannerOpen, setVersionBannerOpen] = useState(true);

    if (location.pathname === "/version-information" || isVersionBannerOpen === false) {
        return;
    }

    return  <div className={layoutStyles.versionInfo}>
                <span className={layoutStyles.versionMessage}>{t("versionInformation.versionInfo")}</span>
                <Link to={"/version-information"}>{t("versionInformation.readMore")}</Link>
                <span className={"btn btn-outline-primary float-end " + styles.closeButton} onClick={() => {setVersionBannerOpen(false)}}>
                   <Icon.Plus size={14} />
                </span>
        </div>;
}
export default VersionInformationBanner;
